import { Button, Pagination } from '@/ui';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding: 1.5rem 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledButton = styled(Button)`
  margin-inline-start: auto;
`;

export const StyledPagination = styled(Pagination)`
  margin-inline: auto;
`;
